Ext.ns('mx.comp');

mx.comp.KeyValueList = Ext.extend(mx.comp.ListField, {
    valueFieldWidth: 250,
    valueFieldShift: 0,
    textFieldShift: 0,

    clsListValue: 'maxoptra-comp-list-value',

    createValueField: function(config) {
        return new Ext.form.TextField(config);
    },

    labelFields: [],

    initComponent: function() {
        /*Ext.apply(this.valueConfig, {
         listeners: {
         render: function(c) {
         Ext.QuickTips.register({
         target: c.getEl(),
         text: 'This field should be a `Key`'
         });
         }
         }
         });
         Ext.apply(this.textConfig, {
         listeners: {
         render: function(c) {
         Ext.QuickTips.register({
         target: c.getEl(),
         text: 'This field should be a `Value`'
         });
         }
         }
         });*/

        mx.comp.KeyValueList.superclass.initComponent.apply(this, arguments);
    },

    onRender: function(ct, position) {
        if (this.isRendered) {
            return;
        }

        var tt = Ext.DomHelper.append(
            ct,
            {
                tag: 'table',
                ls: 'maxoptra-comp-list-table',
                style: 'border-collapse:collapse;',
                children: [this.getLabelRows()],
                id: 'labTabel',
            },
            true
        );

        this.tableElForLabel = tt;
        this.wrapForLabel = tt.wrap();

        this.renderLabelControls();

        // render underlying hidden field
        mx.comp.KeyValueList.superclass.onRender.call(this, ct, position);

        this.isRendered = true;
    },

    renderLabelControls: function() {
        var row = this.tableElForLabel.child('tr.maxoptra-comp-list-tr');

        var keyField = new Ext.form.Label({
            text: 'Property: ',
            style: 'font-weight: bold;',
        });

        var valueField = new Ext.form.Label({
            text: 'Value: ',
            style: 'font-weight: bold;',
        });

        keyField.render(row.child('td.' + 'maxoptra-comp-list-value'));
        valueField.render(row.child('td.' + 'maxoptra-comp-list-text'));

        this.labelFields = [];
        this.labelFields.push(keyField);
        this.labelFields.push(valueField);
    },

    getLabelRows: function() {
        var rows = [];
        rows.push({
            tag: 'tr',
            cls: 'maxoptra-comp-list-tr',
            children: [
                {
                    tag: 'td',
                    cls: 'maxoptra-comp-list-value',
                },
                {
                    tag: 'td',
                    cls: 'maxoptra-comp-list-text',
                },
            ],
        });
        return rows;
    },

    onResize: function(w, h) {
        if (!w) {
            return;
        }
        var padding = this.padding;
        var restWidth = w - padding;
        var valueFieldWidth, textFieldWidth;
        if (this.valueFieldWidth < 1) {
            valueFieldWidth = Math.round(restWidth * this.valueFieldWidth);
        } else {
            valueFieldWidth = this.valueFieldWidth;
        }
        textFieldWidth = restWidth - valueFieldWidth;

        this.labelFields[0].setWidth(valueFieldWidth);
        this.labelFields[0]
            .getEl()
            .parent('td.' + this.clsListValue)
            .setWidth(valueFieldWidth + this.valueFieldShift);
        this.labelFields[1].setWidth(textFieldWidth);
        this.labelFields[1]
            .getEl()
            .parent('td.maxoptra-comp-list-text')
            .setWidth(textFieldWidth + this.textFieldShift);

        mx.comp.KeyValueList.superclass.onResize.call(this, w, h);
    },
});

Ext.reg('mx-keyvaluelist', mx.comp.KeyValueList);
